<div class="app-expansion-panel-trigger-container">
  <app-expansion-panel-button
    [expanded]="expanded"
    (expand)="handleClose()"
  ></app-expansion-panel-button>
</div>
<div class="app-expansion-panel-content">
  <ng-content></ng-content>
</div>
